import { ReactElement } from 'react';
import { Navigate, useNavigate, useRouteLoaderData } from 'react-router-dom';

import { useIncludeFunctionaryForm } from '../../../../contexts/IncludeFunctionaryFormProvider';
import { useLinkStore } from '../../../../stores/useLinkStore';
import { useLoadingStore } from '../../../../stores/useLoadingStore';
import { useWindowSizeStore } from '../../../../stores/useWindowSizeStore';
import { useVerifyDataStore } from '../../../../stores/verifiedStore';
import { Button } from '../../../Button';
import { CartIcon } from '../../../icons/CartIcon';
import Loading from '../../../icons/Loading';
import { GoForwardButton } from '../../GoForwardButton';

export function ConfirmForm(): ReactElement {
  const { watch, handleSubmit, onSubmit } = useIncludeFunctionaryForm();
  const loading = useLoadingStore(state => state.loading);
  const setLoading = useLoadingStore(state => state.setLoading);
  const data: any = useRouteLoaderData('Empresa-token');
  const width = useWindowSizeStore(state => state.width);
  const tryed = useVerifyDataStore(state => state.tryed);
  const verified = useVerifyDataStore(state => state.verify);
  const Iframe = useLinkStore(state => state.data);
  const navigate = useNavigate();

  const associado = watch('user.funcionario');

  const sair = async () => {
    navigate('/');
  };

  return (
    <form className="max-w-[766px] w-full">
      {Iframe ? (
        <>
          <iframe
            src={Iframe}
            width="100%"
            height="700px"
            style={{ border: 'none' }}
          ></iframe>
        </>
      ) : tryed && !verified ? (
        <>
          <>
            <h2 className="text-[2rem] font-semibold text-center text-warning-main">
              Sua adesão não foi concluída!!!
            </h2>
            <p className="font-normal mt-1 text-justify mb-8">
              Caro(a) {associado?.nome}, identificamos que você não é
              sindicalizado no SINPOL-PE. Convidamos você a entrar em contato
              conosco e se sindicalizar.
            </p>
            <p className="font-normal mt-1 text-justify mb-8">
              Você pode entrar em contato pelo telefone: (81)99687-5162 ou pelo
              email secretaria@sinpol-pe.com.br ou indo nos visitar no endereço
              FREI CASSIMIRO 179 - Santo Amaro - CEP: 50100-260
              -RECIFE/PERNAMBUCO, horário de funcionamento de Segunda a Sexta
              feira de 08:00 ao 12:00 e 13:00 às 17:00
            </p>
            <p className="font-normal mt-1 text-justify mb-8">
              Clique no botão abaixo para “Sair”
            </p>
          </>
          <div className="flex justify-end">
            <Button
              text="Sair"
              onClick={sair}
              className="w-[75px] flex flex-direction-reverse"
            >
              Sair
            </Button>
          </div>
        </>
      ) : (
        <>
          <>
            <h2 className="text-[2rem] font-semibold text-center text-primary-main">
              Suas informações foram recebidas com sucesso!
            </h2>
            <p className="font-normal mt-1 text-justify mb-8">
              Confirmamos seu pedido de adesão ao plano odontológico da empresa{' '}
              {data.nome_fantasia}. Sua adesão será comunicada ao RH / Gestor do
              processo de adesão ao plano na sua empresa e assim que aprovada e
              , estando dentro das regras estabelecidas, seu plano será ativado.
            </p>
            <p className="font-normal font-semibold mt-1 text-center mb-8">
              Baixe o aplicativo da Odontogroup e encontre um dentista mais
              próximo de você!
            </p>
          </>
          <div className="flex justify-end">
            <Button
              text="Sair"
              onClick={sair}
              className="w-[75px] flex flex-direction-reverse"
            >
              Sair
            </Button>
          </div>
        </>
      )}
    </form>
  );
}
